import { useFormik } from 'formik';
import { Dispatch, FC, SetStateAction } from 'react';
import styled from 'styled-components';
import { FilePicker } from '../../../../component/filePicker';
import { AddModal } from '../../../../component/modal';
import { useAddBulkProductsMutation } from '../../../../store/shopping/api';
import { showErrorToast, showSuccessToast } from '../../../../utils/toast';

type IAddProducts = {
  show?: boolean;
  storeId: string;
  setShow: Dispatch<SetStateAction<number | null>>;
};
type FormikValues = {
  file: File[] | null;
};
export const AddProductList: FC<IAddProducts> = ({ setShow, storeId }) => {
  const [addProduct, { isLoading: isAdding }] = useAddBulkProductsMutation();
  const handleFilePicked = (file: File[]) => {
    setFieldValue('file', file);
  };

  const handleAddProducts = (values: FormikValues) => {
    if (!values.file) {
      showErrorToast('file is required');
      return;
    }
    const formData = new FormData();
    values.file.forEach((file) => {
      formData.append('file', file);
    });
    formData.append('store', storeId);
    addProduct(formData)
      .unwrap()
      .then((res) => {
        showSuccessToast(res.message);
        setShow(null);
      })
      .catch((error) => {
        showErrorToast(error.message);
      });
  };
  const { setFieldValue, handleSubmit } = useFormik({
    initialValues: {
      file: null
    },
    onSubmit: handleAddProducts
  });

  return (
    <AddModal
      title="Upload List"
      disableBtn={isAdding}
      btnTxt={isAdding ? 'Loading...' : 'Add Product'}
      btnClick={handleSubmit}
      closeModal={() => setShow(null)}
      isLoading={isAdding}
    >
      <Container>
        <CustomFilePicker accept={'.xlsx'} onFilePicked={handleFilePicked} />
      </Container>
    </AddModal>
  );
};

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0px 40px;
  padding-bottom: 32px;
`;

const CustomFilePicker = styled(FilePicker)``;
